import * as React from 'react'
import { useEffect } from 'react'
import { getServiceLocationTitle, LocationDTO } from '@sales-center/common'
import { Select } from '@workwave-tidal/core/components'

type Props = {
  locations: LocationDTO[]
  locationId?: number
  onChange?: (location: LocationDTO | null) => void // callback
}

export function LocationSelector({ locations, locationId, onChange }: Props) {
  const [selectedLocation, setSelectedLocation] =
    React.useState<LocationDTO | null>(null)

  // set initial selection if locationId is provided
  useEffect(() => {
    if (locations.length > 0 && locationId != null) {
      setSelectedLocation(locations.find((l) => l.id === locationId) ?? null)
    }
  }, [locations, locationId])

  const handleChange = (value: LocationDTO | null) => {
    setSelectedLocation(value)
    onChange?.(value)
  }

  return (
    <Select<LocationDTO>
      label="Service Location"
      items={locations}
      value={selectedLocation}
      onChange={handleChange}
      getLabel={(loc) => getServiceLocationTitle(loc) ?? ''}
      getId={(loc) => String(loc.id)}
      optionMode="normal"
      placeholder="Select a Service Location"
      listMode="normal"
      density="compact"
      autocompleteProps={{
        // @ts-expect-error - disableClearable prop type is set to true on tidal
        disableClearable: true,
      }}
      data-test-id="property-details-service-location-select"
    />
  )
}
